import { IOrderBy, OrderType } from "../../../../Global/Base/DataSources/Interfaces";
import { StringUtils } from "../../../../Global/Base/Utils/StringUtils";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { createElement, registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { DropDownMenu } from "../../DropDownMenu/DropDownMenu";
import { DropDownMenuItem } from "../../DropDownMenu/DropDownMenuItem";
import { SeparatorMenuItem } from "../../DropDownMenu/SeparatorItem";
import { TreeViewGrid } from "../../TreeViewGrid";
import { Column } from "../Columns/Column";
import { HeaderRow } from "./HeaderRow";

export class TreeHeaderRow extends HeaderRow {
    protected override _owner: TreeViewGrid;

    private _orderByBtn: HTMLElement;
    private _textElement: HTMLElement;
    private _dropdownArrow: HTMLElement;
    private _nameElement: HTMLElement;
    private _orderBy: IOrderBy;
    private _orderDropDown: DropDownMenu;

    private _descMenuItem: DropDownMenuItem;
    private _ascMenuItem: DropDownMenuItem;

    public set orderBy(v: IOrderBy) {
        this._orderBy = v;

        if (this.disableSort)
            return;

        this._orderByBtn.classList.remove("asc", "desc");
        if (this._orderBy == null) {
            this._descMenuItem.action.enabled = false;
            this._ascMenuItem.action.enabled = false;
            Localization.addLocData(this._textElement, "GUI-639229");
            return;
        }
        this._descMenuItem.action.enabled = true;
        this._ascMenuItem.action.enabled = true;

        if (this._orderBy.order == OrderType.ascending) {
            this._orderByBtn.classList.add("asc");
            //this._orderByBtn.classList.add("desc");
        } else if (this._orderBy.order == OrderType.descending) {
            this._orderByBtn.classList.add("desc");
            //this._orderByBtn.classList.add("asc");
        }
    }

    public get orderBy(): IOrderBy {
        return this._orderBy;
    }

    public override get disableSort(): boolean {
        return super.disableSort;
    }
    public override set disableSort(v: boolean) {
        super.disableSort = v;
        if (v && this._orderByBtn)
            this._orderByBtn.remove();
    }

    private _orderByChangeDispatch(attrName: string, orderType?: OrderType): void {
        const ord: IOrderBy[] = [];
        if (attrName != null) {
            ord.push({
                order: orderType,
                attributeName: attrName,
            });
        }
        this._owner.orderBy = ord;
    }

    /** Nastaví se lokalizační text pro nadpis a jeho viditelnost.  */
    public setCaption(locKey: string, showCaption: boolean): void {
        Localization.addLocData(this._nameElement, locKey);
        this._nameElement.classList.toggle("hidden", !showCaption);
    }

    //#region Methods
    public override render(owner: TreeViewGrid, _columns: Array<Column>, orderBy: IOrderBy[]): void {
        this._owner = owner;

        if (this.disableSort)
            return;

        this._orderDropDown = new DropDownMenu();

        for (const col of owner.columns) {
            const dri = DropDownMenuItem.createDropMenuItem("none", async () => {
                let orderType = OrderType.ascending;
                //let orderType = OrderType.descending;
                if (this.orderBy && this.orderBy.attributeName == col.attrName && this.orderBy.order == orderType)
                //orderType = OrderType.ascending;
                    orderType = OrderType.descending;

                this._orderByChangeDispatch(col.attrName, orderType);

                // Název atributu jako text tlacitko po nastaveni daneho razeni
                if (col.locKey)
                    Localization.addLocData(this._textElement, col.locKey, undefined, undefined, col.locParams);
                else
                    this._textElement.textContent = col.attrName;

                return;
            }, col.locKey, true, undefined, col.locParams);

            if (!col.locKey) { // pokud nemame lokalizacni klic (pokud je treeframe definovany treeatributem, misto jednotlivima atributama) pouzijeme nazev atributu
                dri.setCaption(col.attrName);
            }

            this._orderDropDown.addItem(dri);
        }

        this._descMenuItem = DropDownMenuItem.createDropMenuItem("ui-arrow-bottom", async () => {
            if (!this.orderBy)
                return;
            //TODO: Je třeba předělat obecně, máme přehozeny pložky vzestupně a sestupně
            this._orderByChangeDispatch(this.orderBy.attributeName, OrderType.descending);
            //this._orderByChangeDispatch(this.orderBy.attributeName, OrderType.ascending);
        }, "GUI-584565", false);

        this._ascMenuItem = DropDownMenuItem.createDropMenuItem("ui-arrow-top", async () => {
            if (!this.orderBy)
                return;
            this._orderByChangeDispatch(this.orderBy.attributeName, OrderType.ascending);
            //this._orderByChangeDispatch(this.orderBy.attributeName, OrderType.descending);
        }, "GUI-584564", false);

        this._orderDropDown.addItem(new SeparatorMenuItem());
        this._orderDropDown.addItem(this._ascMenuItem); // Vzestupně
        this._orderDropDown.addItem(this._descMenuItem); // Sestupně
        this._orderDropDown.addItem(DropDownMenuItem.createDropMenuItem("none", async () => {
            this._orderByChangeDispatch(null);
        }, "GUI-602240", true)); // Neřadit
        this.orderBy = orderBy && orderBy.length && orderBy[0].attributeName != "ID" ? orderBy[0] : null;

        if (this.orderBy) {
            const col = owner.columns.find(item => StringUtils.compareCaseInsensitive(item.attrName, this.orderBy.attributeName));
            if (col && col.locKey) {
                Localization.addLocData(this._textElement, col.locKey, undefined, undefined, col.locParams);
            } else
                this._textElement.textContent = this.orderBy.attributeName;
        } else {
            Localization.addLocData(this._textElement, "GUI-639229");
        }
        //}
    }
    //#endregion Methods

    //#region HTMLElement
    protected override _constructor(): void {
        super._constructor();

        this.classList.add("compact", "tree-header-row");
        this._orderByBtn = createElement({ type: "button", classes: "btn flat icon order-by-btn" });
        this._textElement = createElement({ type: "span", classes: "btn-caption order-name no-order" });
        this._dropdownArrow = createElement({ type: "span", classes: "btn-dropdown-icon icon ui-chevron-bottom-small" });
        this._choiceElement.remove();
        this._nameElement = createElement({ type: "span", classes: "grid-name" });

        this._orderByBtn.appendChild(this._textElement);
        this._orderByBtn.appendChild(this._dropdownArrow);
        this.appendChild(this._nameElement);
        this.appendChild(this._orderByBtn);

        this._orderByBtn.addEventListener("click", (e) => {
            if (this._orderDropDown.classList.contains("Disabled"))
                return;
            this._orderDropDown.show(this._orderByBtn, e);
        });
    }

    //#endregion HTMLElement
}

registerCustomElement("tsc-TreeHeaderRow", TreeHeaderRow);
